/**
 * EncounterAuditsTableHeader Component
 *
 * Header row for the encounters table
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

export const EncounterAuditsTableHeader: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '40px 120px 1fr 1fr 1fr 150px 80px 100px 80px 40px',
        gap: 2,
        alignItems: 'center',
        px: 2,
        py: 1.5,
        bgcolor: alpha(theme.palette.primary.main, 0.04),
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
      }}
    >
      {/* Icon */}
      <Box />

      {/* Date */}
      <Typography variant="caption" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
        Date
      </Typography>

      {/* Clinician */}
      <Typography variant="caption" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
        Clinician
      </Typography>

      {/* Patient */}
      <Typography variant="caption" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
        Patient
      </Typography>

      {/* Session Type */}
      <Typography variant="caption" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
        Session Type
      </Typography>

      {/* CPT Codes */}
      <Typography variant="caption" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
        CPT Codes
      </Typography>

      {/* Status */}
      <Typography variant="caption" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
        Status
      </Typography>

      {/* Compliance */}
      <Typography variant="caption" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
        Compliance
      </Typography>

      {/* Quality */}
      <Typography variant="caption" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
        Quality
      </Typography>

      {/* Chevron spacer */}
      <Box />
    </Box>
  );
};
